/**
 * Logger utility for consistent logging across the application.
 * Verbose levels are gated on the Vite DEV flag.
 */
export const logger = {
  log: (...args: unknown[]): void => {
    if (import.meta.env.DEV) {
      console.log('[AfterBooking]', ...args);
    }
  },
  error: (...args: unknown[]): void => {
    console.error('[AfterBooking Error]', ...args);
  },
  warn: (...args: unknown[]): void => {
    if (import.meta.env.DEV) {
      console.warn('[AfterBooking Warning]', ...args);
    }
  },
};
